module.exports = __webpack_public_path__ + "static/media/Bunk bed.546e4ff5.jpg";